import { createSlice } from '@reduxjs/toolkit';
import { findIndex, get } from 'lodash';
export const initialState = {
    request: {
        tcfLoading: false,
        isLoading: true,
        isLoadingStepDetails: true,
        codeExecutionLoading: false,
    },
    data: {
        assessment: null,
        assessmentSection: null,
        currentQuestion: null,
        questions: null,
        answer: null,
        appState: null,
        testInstance: null,
        assessmentSections: [],
        startAssessmentResponse: null,
        startSectionResponse: null,
        next_question_id: null,
        questionsIds: [],
        answers: [],
        currentAssessmentSectionId: undefined,
        parsedMaxSectionTime: null,
        assessmentError: null,
        tcfMeasurement: null,
        candidate_id: undefined,
        updateTotalAssessmentTime: null,
        step: null,
        assessmentPreform: null,
        workflowCandidateStepId: null,
        workflowCandidateStepIdLookup: { status: 'idle', id: null, testInstanceId: null },
        ivyReportDetails: null,
        languageReport: null,
        combinedReport: null,
        shouldRedirectToStatusError: false,
        isCompletedRevisit: false,
        codeSoloStatus: null,
        codeExecutionResult: null,
        codeExecutionError: null,
        onboardingWaitInfo: {
            shouldShow: false,
            startsAt: null,
            expiredAt: null,
            windowType: null,
            actionVariant: null,
        },
    },
    preInstructionState: {
        hasPreform: false,
        preformSubmitted: false,
        formId: null,
        faceAuthCompleted: false,
        isCandidateAuthEnabled: false,
    },
};
const assessmentSliceImpl = createSlice({
    name: 'assessment',
    initialState,
    reducers: {
        initialize: (state, _action) => ({
            ...initialState,
            preInstructionState: state.preInstructionState,
            request: {
                ...initialState.request,
                isLoading: true,
            },
        }),
        startAssessment: (_state, _action) => {
            // state.request.isLoading = true;
        },
        startAssessmentError: (state, action) => {
            state.data.assessmentError = action.payload.error;
            state.request.isLoading = false;
        },
        storeAssessment: (state, action) => {
            state.data.assessment = action.payload?.assessment;
            state.data.currentAssessmentSectionId = action.payload?.assessmentSection.id;
            state.data.assessmentSections = action.payload?.assessmentSections;
            state.data.startAssessmentResponse = action.payload?.startAssessmentResponse;
            state.request.isLoading = false;
        },
        resetSectionState: (state) => {
            state.request.tcfLoading = false;
            state.data.assessmentSection = null;
            state.data.currentQuestion = null;
            state.data.questions = null;
            state.data.answer = null;
            state.data.appState = null;
            state.data.startSectionResponse = null;
            state.data.next_question_id = null;
            state.data.questionsIds = [];
            state.data.answers = [];
            state.data.currentAssessmentSectionId = undefined;
            state.data.parsedMaxSectionTime = null;
            state.data.tcfMeasurement = null;
        },
        startSection: (_state, _action) => {
            // state.request.isLoading = true
        },
        storeSection: (state, action) => {
            state.data.assessmentSection = action.payload.assessmentSection;
            state.data.startSectionResponse = action.payload.startSectionResponse;
            state.data.next_question_id = action.payload.next_question_id;
            state.data.questionsIds = action.payload.questionsIds;
            state.data.parsedMaxSectionTime = action.payload.parsedMaxSectionTime;
            state.data.answers = action.payload.answers;
        },
        submitSection: (_state, _action) => {
            // state.request.isLoading = true
        },
        storeStopSection: (state, action) => {
            state.data.startSectionResponse = action.payload.startSectionResponse;
        },
        fetchNextQuestionById: (state, _action) => {
            state.data.answer = null;
        },
        fetchNextQuestionFromCollection: (state, _action) => {
            state.data.answer = null;
        },
        storeNextQuestion: (state, action) => {
            state.data.currentQuestion = action.payload.data;
            state.data.next_question_id = action.payload.next_question_id;
        },
        fetchQuestionsList: () => {
            // state.request.isLoading = true
        },
        storeQuestionList: (state, action) => {
            state.data.questions = action.payload.data;
        },
        executeCode: (state, _action) => {
            state.request.codeExecutionLoading = true;
            state.data.codeExecutionError = null;
        },
        subscribeExecuteCode: (_state, _action) => {
            // subscription handled via saga
        },
        storeExecuteCodeResult: (state, action) => {
            state.request.codeExecutionLoading = false;
            state.data.codeExecutionResult = action.payload;
        },
        executeCodeFailure: (state, action) => {
            state.request.codeExecutionLoading = false;
            state.data.codeExecutionError = action.payload;
        },
        resetExecuteCodeLoading: (state) => {
            state.request.codeExecutionLoading = false;
        },
        saveAnswer: (_state, _action) => {
            // state.request.isLoading = true
        },
        storeAnswer: (state, action) => {
            state.data.answer = action.payload;
            const payloadLanguage = get(action.payload, 'code_response.doc.language_used.language');
            const index = findIndex(state.data.answers, (answer) => {
                if (answer?.question_id !== action?.payload?.question_id)
                    return false;
                if (!payloadLanguage)
                    return true;
                const answerLanguage = get(answer, 'code_response.doc.language_used.language');
                return answerLanguage === payloadLanguage;
            });
            if (index !== -1) {
                state.data.answers[index] = action.payload;
            }
            else {
                state.data.answers.push(action.payload);
            }
        },
        storeBulkAnswer: (state, action) => {
            state.data.answers = action.payload;
        },
        stopSection: (_state, _action) => {
            // state.request.isLoading = true;
        },
        fetchTcfMeasure: (state, _action) => {
            state.request.tcfLoading = true;
        },
        saveAppState: (_state, _action) => {
            // state.request.isLoading = true
        },
        syncAppState: (_state, _action) => {
            // trigger only
        },
        codeSoloSyncAppStateFlushed: (_state) => {
            // trigger only
        },
        storeAppState: (state, action) => {
            state.data.appState = action.payload;
        },
        getAppState: (_state, _action) => {
            // state.request.isLoading = true;
        },
        storeTcfMeasurement: (state, action) => {
            state.request.tcfLoading = false;
            state.data.tcfMeasurement = action.payload;
        },
        fetchTestInstance: (_state, _action) => {
            // state.request.isLoading = true;
        },
        saveBulkAnswer: (_state, _action) => {
            // state.request.isLoading = true;
        },
        updatePreInstructionState: (state, action) => {
            state.preInstructionState.hasPreform = action?.payload?.hasPreform || state.preInstructionState.hasPreform;
            state.preInstructionState.preformSubmitted =
                action?.payload?.preformSubmitted || state.preInstructionState.preformSubmitted;
            state.preInstructionState.formId = action?.payload?.formId || state.preInstructionState.formId;
        },
        setUpdatedParsedMaxSectionTime: (state, action) => {
            if (state.data.parsedMaxSectionTime === null) {
                state.data.parsedMaxSectionTime = action.payload;
            }
        },
        resetParsedMaxSectionTime: (state) => {
            state.data.parsedMaxSectionTime = null;
        },
        updateTotalAssessmentTime: (state, action) => {
            state.data.updateTotalAssessmentTime = action.payload;
        },
        getStepDetails: (state, _action) => {
            // trigger only
            state.request.isLoadingStepDetails = true;
        },
        storeStepDetails: (state, action) => {
            state.data.step = action.payload;
            state.request.isLoadingStepDetails = false;
        },
        setOnboardingWaitInfo: (state, action) => {
            state.data.onboardingWaitInfo = {
                shouldShow: action.payload.shouldShow,
                startsAt: action.payload.startsAt ?? null,
                expiredAt: action.payload.expiredAt ?? null,
                windowType: action.payload.windowType ?? null,
                actionVariant: action.payload.actionVariant ?? null,
            };
        },
        setShouldRedirectToStatusError: (state, action) => {
            state.data.shouldRedirectToStatusError = action.payload;
        },
        setIsCompletedRevisit: (state, action) => {
            state.data.isCompletedRevisit = action.payload;
        },
        storeWorkflowCandidateStepId: (state, action) => {
            state.data.workflowCandidateStepId = action.payload;
        },
        updateAssessmentPreformRequest: (_state, _action) => {
            //
        },
        lookUpWorkflowCandidateStepId: (state, action) => {
            state.data.workflowCandidateStepIdLookup = {
                status: 'loading',
                id: null,
                testInstanceId: action.payload.test_instance_id,
            };
        },
        storeWorkflowCandidateStepIdLookup: (state, action) => {
            state.data.workflowCandidateStepIdLookup = {
                ...state.data.workflowCandidateStepIdLookup,
                status: 'done',
                id: action.payload,
            };
        },
        triggerTimeUp: (_state, _action) => {
            //
        },
        fetchIvyReportDetails: (_state, _action) => {
            //
        },
        storeIvyReportDetails: (state, action) => {
            state.data.ivyReportDetails = action.payload;
        },
        fetchLanguageSpeakingReport: (_state, _action) => {
            //
        },
        storeLanguageReport: (state, action) => {
            state.data.languageReport = action.payload;
        },
        resetLanguageReport: (state) => {
            state.data.languageReport = null;
        },
        fetchCombinedReport: (_state, _action) => { },
        storeCombinedReport: (state, action) => {
            state.data.combinedReport = action.payload;
        },
        resetCombinedReport: (state) => {
            state.data.combinedReport = null;
        },
        storeStartSectionResponse: (state, action) => {
            state.data.startSectionResponse = action.payload;
        },
        faceAuthStateUpdate: (state, action) => {
            state.preInstructionState.faceAuthCompleted = action.payload.faceAuthCompleted;
            state.preInstructionState.isCandidateAuthEnabled = action.payload.isCandidateAuthEnabled;
        },
        formSubmissionStateUpdate: (state, action) => {
            state.preInstructionState.preformSubmitted = action.payload.preformSubmitted;
        },
        setCodeSoloStatus: (state, action) => {
            state.data.codeSoloStatus = action.payload;
        },
    },
});
// TS4023: explicit annotation prevents immer WritableNonArrayDraft from leaking into declarations
export const assessmentSlice = assessmentSliceImpl;
export const { initialize, startAssessment, startSection, resetSectionState, submitSection, fetchNextQuestionById, fetchQuestionsList, saveAnswer, executeCode, subscribeExecuteCode, storeExecuteCodeResult, executeCodeFailure, resetExecuteCodeLoading, stopSection, fetchTcfMeasure, saveAppState, syncAppState, codeSoloSyncAppStateFlushed, storeAssessment, storeSection, storeNextQuestion, storeQuestionList, storeAnswer, storeAppState, getAppState, storeStopSection, fetchTestInstance, startAssessmentError, storeTcfMeasurement, fetchNextQuestionFromCollection, saveBulkAnswer, storeBulkAnswer, storeStepDetails, storeWorkflowCandidateStepId, updatePreInstructionState, setUpdatedParsedMaxSectionTime, resetParsedMaxSectionTime, updateTotalAssessmentTime, getStepDetails, updateAssessmentPreformRequest, lookUpWorkflowCandidateStepId, storeWorkflowCandidateStepIdLookup, triggerTimeUp, fetchIvyReportDetails, storeIvyReportDetails, fetchLanguageSpeakingReport, storeLanguageReport, resetLanguageReport, fetchCombinedReport, storeCombinedReport, resetCombinedReport, storeStartSectionResponse, faceAuthStateUpdate, formSubmissionStateUpdate, setCodeSoloStatus, setOnboardingWaitInfo, } = assessmentSliceImpl.actions;
export const setShouldRedirectToStatusError = assessmentSliceImpl.actions.setShouldRedirectToStatusError;
export const setIsCompletedRevisit = assessmentSliceImpl.actions.setIsCompletedRevisit;
export default assessmentSliceImpl.reducer;
